/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Mountain_ViewInputs */

const cs_enum_mountain_view = /** @type {(inputs: Enum_Mountain_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Výhled na hory`)
};

const en_enum_mountain_view = /** @type {(inputs: Enum_Mountain_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mountain view`)
};

/**
* | output |
* | --- |
* | "Mountain view" |
*
* @param {Enum_Mountain_ViewInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_mountain_view = /** @type {((inputs?: Enum_Mountain_ViewInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Mountain_ViewInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_mountain_view(inputs)
	return cs_enum_mountain_view(inputs)
});